<main role="main" class="page-organisation not-home-page">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <app-breadcrumb></app-breadcrumb>
        <h2>{{"organisation.title" |translate}}</h2>
        <p class="text-primary size18 font-weight-semibold">{{"organisation.p1" |translate}}</p>
        <p>{{"organisation.p2" |translate}}</p>
        <p>{{"organisation.p3" |translate}}</p>
        <form class="rounded-form" action="" method="get">
          <div class="form-group d-flex">
            <select class="form-control" name="Direction" id="direction" [(ngModel)]="selectedDirection"
              (change)="changeDirection()">
              <option value="">{{"organisation.choixDirection" |translate}}</option>
              <option *ngFor="let item of directions; let index = index" [value]="item">{{langue === 'fr' ? item : (langue === 'ar' ? directionsTab[index].ar : directionsTab[index].en)}}</option>

            </select>
            <button class="btn btn-primary pr-5" type="submit"> <span class="icon-search"></span></button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <section class="c-accordion-full">
    <button  type="submit" class="btn btn-link arrowLeft" (click)="bacKOrganisation()" *ngIf="selectedOrga">
      <span  class="icon-long-right-arrow"></span>
    </button>
    <div class="container">
      <div class="row" *ngIf="!selectedOrga">
        <div class="col-md-12">
          <div class="block-organisation">
            <!--DG-->
            <div class="d-flex justify-content-center">
              <div class="card big mb-3" (click) ="showModalPerson(dg[0])" >
                <div class="row no-gutters">
                  <div class="col-md-4"><img class="card-img" [src]="getItemPicture(dg[0]?.metadata)"
                      alt="MUSTPHA FARES"></div>
                  <div class="col">
                    <div class="card-body" *ngIf="dg.length>0">
                      <div class="card-title" *ngIf="langue.toUpperCase() ==='FR'">{{dg[0]?.metadata.IntitulePoste}}
                      </div>
                      <div class="card-title" *ngIf="langue.toUpperCase() ==='EN'">{{dg[0]?.metadata.IntitulePosteEN}}
                      </div>
                      <p class="card-text" *ngIf="langue.toUpperCase() !=='AR'"> {{dg[0]?.metadata.NomPrenom}}</p>
                      <div class="card-title" *ngIf="langue.toUpperCase() ==='AR'">{{dg[0]?.metadata.IntitulePosteAR}}
                      </div>
                      <p class="card-text" *ngIf="langue.toUpperCase() ==='AR'">{{dg[0]?.metadata.NomPrenomAR}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row line1">
              <!--Gouvernance-->
              <div class="col-lg-3">
                <div class="accord-list">
                  <div class="accord-title bg-info style1">{{"organisation.Gouvernance" |translate}}</div>
                  <div class="accord-cards">
                    <div class="card mb-3" (click)="getDirection(dr)" *ngFor="let dr of dGouvernance">
                      <div class="row no-gutters">
                        <div class="col-md-4"><img class="card-img" [src]="getItemPicture(dr?.metadata)" alt="..."></div>
                        <div class="col">
                          <div class="card-body">
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='FR'">
                              {{trunkIntitule(dr.metadata.IntitulePoste)}}</div>
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='EN'">
                              {{trunkIntitule(dr.metadata.IntitulePosteEN)}}</div>
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='AR'">
                              {{trunkIntitule(dr.metadata.IntitulePosteAR)}}</div>
                            <p class="card-text" *ngIf="langue.toUpperCase() !=='AR'">{{dr.metadata.NomPrenom !=='Poste
                              Vacant'? dr.metadata.NomPrenom : (dr.metadata.Interime === 'Interim1' ?  '' : dr.metadata.Interime) }}</p>
                            <p class="card-text" *ngIf="langue.toUpperCase() ==='AR'">{{dr.metadata.NomPrenom !=='Poste
                              Vacant'? dr.metadata.NomPrenomAR : (dr.metadata.Interime === 'Interim1' ?  '' : dr.metadata.Interime)}}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <!--stratégie-->
              <div class="col-lg-3">
                <div class="accord-list">
                  <div class="accord-title bg-info style1">{{"organisation.Strategie" |translate}}</div>
                  <div class="accord-cards">
                    <div class="card mb-3" (click)="getDirection(item)" *ngFor="let item of dPoleStrategique">
                      <div class="row no-gutters">
                        <div class="col-md-4"><img class="card-img" [src]="getItemPicture(item.metadata)" alt="...">
                        </div>
                        <div class="col">
                          <div class="card-body">
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='FR'">
                              {{trunkIntitule(item.metadata.IntitulePoste)}}</div>
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='EN'">
                              {{trunkIntitule(item.metadata.IntitulePosteEN)}}</div>
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='AR'">
                              {{trunkIntitule(item.metadata.IntitulePosteAR)}}</div>
                            <p class="card-text" *ngIf="langue.toUpperCase() !=='AR'">{{item.metadata.NomPrenom
                              !=='Poste Vacant'? item.metadata.NomPrenom : (item.metadata.Interime === 'Interim1' ?  '' : item.metadata.Interime)}}</p>
                            <p class="card-text" *ngIf="langue.toUpperCase() ==='AR'">{{item.metadata.NomPrenom
                              !=='Poste Vacant'? item.metadata.NomPrenomAR : (item.metadata.Interime === 'Interim1' ?  '' : item.metadata.Interime)}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--div class="accord-list">
                  <div class="accord-title bg-info style2">{{"organisation.IFP" |translate}}</div>
                  <div class="accord-cards">
                    <div class="card mb-3" (click)="getDirection(item)" *ngFor="let item of dIFP">
                      <div class="row no-gutters">
                        <div class="col-md-4"><img class="card-img" [src]="getItemPicture(item?.metadata)" alt="...">
                        </div>
                        <div class="col">
                          <div class="card-body">
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='FR'">
                              {{trunkIntitule(item.metadata.IntitulePoste)}}</div>
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='EN'">
                              {{trunkIntitule(item.metadata.IntitulePosteEN)}}</div>
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='AR'">
                              {{trunkIntitule(item.metadata.IntitulePosteAR)}}</div>
                            <p class="card-text" *ngIf="langue.toUpperCase() !=='AR'">{{item.metadata.NomPrenom
                              !=='Poste Vacant'? item.metadata.NomPrenom : (item.metadata.Interime === 'Interim1' ?  '' : item.metadata.Interime)}}</p>
                            <p class="card-text" *ngIf="langue.toUpperCase() ==='AR'">{{item.metadata.NomPrenom
                              !=='Poste Vacant'? item.metadata.NomPrenomAR : (item.metadata.Interime === 'Interim1' ?  '' : item.metadata.Interime)}}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div-->
              </div>
              <!-- Metiers-->
              <div class="col-lg-3">
                <div class="accord-list">
                  <div class="accord-title bg-info style1">{{"organisation.Metiers" |translate}}</div>
                  <div class="accord-cards">
                    <div class="card mb-3" (click)="getDirection(item)" *ngFor="let item of dPoleTechnique">
                      <div class="row no-gutters">
                        <div class="col-md-4"><img class="card-img" [src]="getItemPicture(item?.metadata)" alt="...">
                        </div>
                        <div class="col">
                          <div class="card-body">
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='FR'">
                              {{trunkIntitule(item.metadata.IntitulePoste)}}</div>
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='EN'">
                              {{trunkIntitule(item.metadata.IntitulePosteEN)}}</div>
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='AR'">
                              {{trunkIntitule(item.metadata.IntitulePosteAR)}}</div>
                            <p class="card-text" *ngIf="langue.toUpperCase() !=='AR'">{{item.metadata.NomPrenom
                              !=='Poste Vacant'? item.metadata.NomPrenom : (item.metadata.Interime === 'Interim1' ?  '' : item.metadata.Interime)}}</p>
                            <p class="card-text" *ngIf="langue.toUpperCase() ==='AR'">{{item.metadata.NomPrenom
                              !=='Poste Vacant'? item.metadata.NomPrenomAR : (item.metadata.Interime === 'Interim1' ?  '' : item.metadata.Interime)}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--div class="accord-list">
                  <div class="accord-title bg-info style3">{{"organisation.Missions" | translate}}</div>
                  <div class="accord-cards">
                    <div class="card mb-3" (click)="getDirection(item)" *ngFor="let item of dMissions">
                      <div class="row no-gutters">
                        <div class="col-md-4"><img class="card-img" [src]="getItemPicture(item?.metadata)" alt="...">
                        </div>
                        <div class="col">
                          <div class="card-body">
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='FR'">
                              {{trunkIntitule(item.metadata.IntitulePoste)}}</div>
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='EN'">
                              {{trunkIntitule(item.metadata.IntitulePosteEN)}}</div>
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='AR'">
                              {{trunkIntitule(item.metadata.IntitulePosteAR)}}</div>
                            <p class="card-text" *ngIf="langue.toUpperCase() !=='AR'">{{item.metadata.NomPrenom
                              !=='Poste Vacant'? item.metadata.NomPrenom : (item.metadata.Interime === 'Interim1' ?  '' : item.metadata.Interime)}}</p>
                            <p class="card-text" *ngIf="langue.toUpperCase() ==='AR'">{{item.metadata.NomPrenom
                              !=='Poste Vacant'? item.metadata.NomPrenomAR : (item.metadata.Interime === 'Interim1' ?  '' : item.metadata.Interime)}}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div-->
              </div>
              <!--Ressources-->
              <div class="col-lg-3">
                <div class="accord-list">
                  <div class="accord-title bg-info style1">{{"organisation.Ressources" | translate}}</div>
                  <div class="accord-cards">
                    <div class="card mb-3" (click)="getDirection(item)" *ngFor="let item of dSupport">
                      <div class="row no-gutters">
                        <div class="col-md-4"><img class="card-img" [src]="getItemPicture(item?.metadata)" alt="...">
                        </div>
                        <div class="col">
                          <div class="card-body">
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='FR'">
                              {{trunkIntitule(item.metadata.IntitulePoste)}}</div>
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='EN'">
                              {{trunkIntitule(item.metadata.IntitulePosteEN)}}</div>
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='AR'">
                              {{trunkIntitule(item.metadata.IntitulePosteAR)}}</div>
                            <p class="card-text" *ngIf="langue.toUpperCase() !=='AR'">{{item.metadata.NomPrenom
                              !=='Poste Vacant'? item.metadata.NomPrenom : (item.metadata.Interime === 'Interim1' ?  '' : item.metadata.Interime)}}</p>
                            <p class="card-text" *ngIf="langue.toUpperCase() ==='AR'">{{item.metadata.NomPrenom
                              !=='Poste Vacant'? item.metadata.NomPrenomAR : (item.metadata.Interime === 'Interim1' ?  '' : item.metadata.Interime)}}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <!--DirectionRegionales-->
            <div class="row line2">
              <div class="col-md-12">
                <div class="accord-list">
                  <div class="accord-title bg-info large">{{"organisation.DirectionRegionales" | translate}}</div>
                </div>
                <div class="row no-gutters">
                  <div class="col-lg-3"  *ngFor="let item of dDepartementN1; let i=index">
                    <div class="accord-cards" >
                      <div class="card mb-3" (click)="getDirection(item)" >
                        <div class="row no-gutters">
                          <div class="col-md-4"><img class="card-img" [src]="getItemPicture(item?.metadata)" alt="...">
                          </div>
                          <div class="col">
                            <div class="card-body">
                              <div class="card-title" *ngIf="langue.toUpperCase() ==='FR'">
                                {{trunkIntitule(item.IntitulePoste)}}</div>
                              <div class="card-title" *ngIf="langue.toUpperCase() ==='EN'">
                                {{trunkIntitule(item.metadata.IntitulePosteEN)}}</div>
                              <div class="card-title" *ngIf="langue.toUpperCase() ==='AR'">
                                {{trunkIntitule(item.metadata.IntitulePosteAR)}}</div>
                              <p class="card-text" *ngIf="langue.toUpperCase() !=='AR'">{{item.metadata.NomPrenom
                                !=='Poste Vacant'? item.metadata.NomPrenom : (item.metadata.Interime === 'Interim1' ?  '' : item.metadata.Interime)}}</p>
                              <p class="card-text" *ngIf="langue.toUpperCase() ==='AR'">{{item.metadata.NomPrenom
                                !=='Poste Vacant'? item.metadata.NomPrenomAR : (item.metadata.Interime === 'Interim1' ?  '' : item.metadata.Interime)}}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card mb-3" (click)="getDirection(dDepartementN2[i])" *ngIf="dDepartementN2[i]">
                        <div class="row no-gutters">
                          <div class="col-md-4"><img class="card-img" [src]="getItemPicture(dDepartementN2[i]?.metadata)"
                              alt="..."></div>
                          <div class="col">
                            <div class="card-body">
                              <div class="card-title" *ngIf="langue.toUpperCase() ==='FR'">
                                {{trunkIntitule(dDepartementN2[i].IntitulePoste)}}</div>
                              <div class="card-title" *ngIf="langue.toUpperCase() ==='EN'">
                                {{trunkIntitule(dDepartementN2[i].metadata.IntitulePosteEN)}}</div>
                              <div class="card-title" *ngIf="langue.toUpperCase() ==='AR'">
                                {{trunkIntitule(dDepartementN2[i].metadata.IntitulePosteAR)}}</div>
                              <p class="card-text" *ngIf="langue.toUpperCase() !=='AR'">
                                {{dDepartementN2[i].metadata.NomPrenom !=='Poste Vacant'?
                                dDepartementN2[i].metadata.NomPrenom :  (dDepartementN2[i].metadata.Interime === 'Interim1' ?  '' : dDepartementN2[i].metadata.Interime)}}</p>
                              <p class="card-text" *ngIf="langue.toUpperCase() ==='AR'">
                                {{dDepartementN2[i].metadata.NomPrenom !=='Poste Vacant'?
                                dDepartementN2[i].metadata.NomPrenomAR : (dDepartementN2[i].metadata.Interime === 'Interim1' ?  '' : dDepartementN2[i].metadata.Interime)}}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="card mb-3" (click)="getDirection(dDepartementN3[i])" *ngIf="dDepartementN3[i]">
                        <div class="row no-gutters">
                          <div class="col-md-4"><img class="card-img" [src]="getItemPicture(dDepartementN3[i]?.metadata)"
                              alt="..."></div>
                          <div class="col">
                            <div class="card-body">
                              <div class="card-title" *ngIf="langue.toUpperCase() ==='FR'">
                                {{trunkIntitule(dDepartementN3[i].IntitulePoste)}}</div>
                              <div class="card-title" *ngIf="langue.toUpperCase() ==='EN'">
                                {{trunkIntitule(dDepartementN3[i].metadata.IntitulePosteEN)}}</div>
                              <div class="card-title" *ngIf="langue.toUpperCase() ==='AR'">
                                {{trunkIntitule(dDepartementN3[i].metadata.IntitulePosteAR)}}</div>
                              <p class="card-text" *ngIf="langue.toUpperCase() !=='AR'">
                                {{dDepartementN3[i].metadata.NomPrenom !=='Poste Vacant'?
                                dDepartementN3[i].metadata.NomPrenom :  (dDepartementN3[i].metadata.Interime === 'Interim1' ?  '' : dDepartementN3[i].metadata.Interime)}}</p>
                              <p class="card-text" *ngIf="langue.toUpperCase() ==='AR'">
                                {{dDepartementN3[i].metadata.NomPrenom !=='Poste Vacant'?
                                dDepartementN3[i].metadata.NomPrenomAR : (dDepartementN3[i].metadata.Interime === 'Interim1' ?  '' : dDepartementN3[i].metadata.Interime)}}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="selectedOrga">
        <div class="col-md-12">
          <div class="block-organisation">
            <div class="d-flex justify-content-center">
              <div class="card big mb-3" (click) ="showModalPerson(miniOrganisation)"  >
                <div class="row no-gutters">
                  <div class="col-md-4"><img class="card-img" [src]="getItemPicture(miniOrganisation?.Responsable)" />
                  </div>
                  <div class="col">
                    <div class="card-body" *ngIf="dg.length>0">
                      <div class="card-title" *ngIf="langue.toUpperCase() ==='FR'">
                        {{miniOrganisation.Responsable?.IntitulePoste}}
                      </div>
                      <div class="card-title" *ngIf="langue.toUpperCase() ==='EN'">
                        {{miniOrganisation.Responsable?.IntitulePosteEN}}
                      </div>

                      <div class="card-title" *ngIf="langue.toUpperCase() ==='AR'">
                        {{miniOrganisation.Responsable?.IntitulePosteAR}}
                      </div>
                      <p class="card-text" *ngIf="langue.toUpperCase() !=='AR'">{{miniOrganisation.Responsable?.NomPrenom
                        !=='Poste Vacant'? miniOrganisation.Responsable?.NomPrenom :
                        (miniOrganisation.Responsable.Interime === 'Interim1' ?  '' : miniOrganisation.Responsable.Interime) }}</p>
                      <p class="card-text" *ngIf="langue.toUpperCase() ==='AR'">{{miniOrganisation.Responsable?.NomPrenom
                        !=='Poste Vacant'? miniOrganisation.Responsable?.NomPrenomAR :
                        (miniOrganisation.Responsable.Interime === 'Interim1' ?  '' : miniOrganisation.Responsable.Interime)}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngFor="let members of chunk()" class="row line1 d-flex" [class.noline]="members.length == 1">
              <div *ngFor="let member of members;let index=index"  (click) ="showModalPerson(member)" [class.automargr]="members.length != 1 && !index"
                [class.automargl]="members.length != 1 && members.length-1 == index" class="col-lg-3">
                <div class="accord-list">
                  <div class="accord-title bg-info style1 ">
                    <div class="row no-gutters" style="background-color: unset; margin: 0;">
                      <div class="col-md-4"><img class="card-img" [src]="getItemPicture(member?.Responsable)" alt="...">
                      </div>
                      <div class="col">
                        <div class="card-body">
                          <div class="card-title" *ngIf="langue.toUpperCase() ==='FR'">
                            {{trunkIntitule(member.Responsable.IntitulePoste)}}</div>
                          <div class="card-title" *ngIf="langue.toUpperCase() ==='EN'">
                            {{trunkIntitule(member.Responsable.IntitulePosteEN)}}</div>
                          <div class="card-title" *ngIf="langue.toUpperCase() ==='AR'">
                            {{trunkIntitule(member.Responsable.IntitulePosteAR)}}</div>

                          <p class="card-text" *ngIf="langue.toUpperCase() !=='AR'">{{member.Responsable.NomPrenom
                            !=='Poste Vacant'? member.Responsable.NomPrenom : (member.Responsable.Interime === 'Interim1' ?  '' : member.Responsable.Interime)}}</p>
                          <p class="card-text" *ngIf="langue.toUpperCase() ==='AR'">{{member.Responsable.NomPrenom
                            !=='Poste Vacant'? member.Responsable.NomPrenomAR : (member.Responsable.Interime === 'Interim1' ?  '' : member.Responsable.Interime)}}</p>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="accord-cards" *ngIf="member.Members?.length">
                    <div class="card mb-3" *ngFor="let m of member.Members" (click) ="showModalPerson(m)">
                      <div class="row no-gutters">
                        <div class="col-md-4"><img class="card-img" [src]="getItemPicture(m.Responsable)" alt="...">
                        </div>
                        <div class="col">
                          <div class="card-body">
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='FR'">
                              {{trunkIntitule(m.Responsable.IntitulePoste)}}</div>
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='EN'">
                              {{trunkIntitule(m.Responsable.IntitulePosteEN)}}</div>
                            <div class="card-title" *ngIf="langue.toUpperCase() ==='AR'">
                              {{trunkIntitule(m.Responsable.IntitulePosteAR)}}</div>
                            <p class="card-text" *ngIf="langue.toUpperCase() !=='AR'">{{m.Responsable.NomPrenom
                              !=='Poste Vacant'? m.Responsable.NomPrenom : (m.Responsable.Interime === 'Interim1' ?  '' : m.Responsable.Interime)}}</p>
                            <p class="card-text" *ngIf="langue.toUpperCase() ==='AR'">{{m.Responsable.NomPrenom
                              !=='Poste Vacant'? m.Responsable.NomPrenomAR : (m.Responsable.Interime === 'Interim1' ?  '' : m.Responsable.Interime)}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <ul *ngIf="this.miniOrganisation" >
      <li *ngFor="let item of this.miniOrganisation.Members" >
        {{item.Responsable.IntitulePoste}}
        <ul *ngIf="item.Members">
          <li *ngFor="let div of this.item.Members">
            {{div.Responsable.IntitulePoste}}
            <ul *ngIf="div.Members">
              <li *ngFor="let sr of this.div.Members">
                {{sr.Responsable.IntitulePoste}}
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul> -->
  </section>
</main>


<!-- detail de profile -->

<!-- Button trigger modal -->
<button type="button" class="btn btn-primary" data-toggle="modal" id="showProfile" style='display: none;' data-target="#exampleModal">
  Demarrer le modal
</button>

<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content" *ngIf="showItemProfile">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{showItemProfile.IntitulePoste}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" >
        <div class="row">
          <div class="col-md-6 img">
            <img [src]="getItemPicture(showItemProfile)"  alt="" class="img-rounded">
          </div>
          <div class="col-md-6 details" >
            <p >
           {{"organisation.NomPrennom" |translate}} : <small *ngIf="langue.toUpperCase() ==='AR'">{{showItemProfile.NomPrenomAR}}</small> 
           <small *ngIf="langue.toUpperCase() !=='AR'">{{showItemProfile.NomPrenom}}</small> 
           <br>
                                     
             {{"organisation.IntitulePoste" |translate}}:
             <small *ngIf="langue.toUpperCase() ==='EN'">{{showItemProfile.IntitulePosteEN}}</small>
            <small *ngIf="langue.toUpperCase() ==='FR'">{{showItemProfile.IntitulePoste}}</small>
             <small *ngIf="langue.toUpperCase() ==='AR'">{{showItemProfile.IntitulePosteAR}}</small>
             
             <br>
            
             <span *ngIf="showItemProfile?.Email">{{"organisation.Mail" |translate}} : <small>{{showItemProfile.Email}}</small> <br/></span>
             <span *ngIf="showItemProfile?.Telephone">{{"organisation.Telephone" |translate}} : <small>{{showItemProfile.Telephone}}</small> <br/></span>
            
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>